import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition } from "vue";
import _imports_0 from '@/assets/img/logo-ico-lh.png';
const _hoisted_1 = {
  class: "layout"
};
const _hoisted_2 = {
  class: "tab-box"
};
const _hoisted_3 = {
  class: "flex-center-col big-top-title xxx"
};
const _hoisted_4 = {
  key: 0,
  class: "top-avatar flex gap-1"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "menu-list-item flex-center-col"
};
const _hoisted_8 = {
  class: "more-menus"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_11 = {
  class: "menu-list-item flex-center-col"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  class: "more-menus setting-menus"
};
const _hoisted_14 = {
  class: "username title"
};
const _hoisted_15 = {
  class: "menu-bot-item"
};
const _hoisted_16 = {
  key: 0,
  class: "topheader"
};
const _hoisted_17 = {
  class: "content custom-scroll"
};
const _hoisted_18 = {
  class: "p-4 pt-2 pb-2"
};
import { Setting, UserFilled, MoreFilled } from "@element-plus/icons-vue";
import ThemeChange from "@/components/ThemeChange.vue";
import { useRouter } from "vue-router";
import { onMounted, ref, watch } from "vue";
import { httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { checkSession, getLicenseInfo, getNavMenuInfo, getSystemInfo } from "@/store/cache";
import { removeUserToken } from "@/store/session";
import { useSharedStore } from "@/store/sharedata";
import { useUserStoreWithOut } from "@/store/modules/user";
import ConfigDialog from "@/components/UserInfoDialog.vue";
import { showMessageError } from "@/utils/dialog";
import LoginDialog from "@/components/LoginDialog.vue";
import Icon from '@/components/Icon/src/Icon.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {
    const userStore = useUserStoreWithOut();
    const isCollapse = ref(true);
    const router = useRouter();
    const logo = ref("");
    const mainNavs = ref([]);
    const moreNavs = ref([]);
    const curPath = ref();
    const title = ref("");
    const avatarImg = ref("/images/avatar/default.jpg");
    const store = useSharedStore();
    const loginUser = ref({});
    const routerViewKey = ref(0);
    const showConfigDialog = ref(false);
    const license = ref({
      de_copy: true
    });
    const gitURL = ref(process.env.VUE_APP_GIT_URL);
    const showLoginDialog = ref(false);
    /**
     * 从路径名中提取第一个路径段
     * @param pathname - URL 的路径名部分，例如 '/chat/12345'
     * @returns 第一个路径段（不含斜杠），例如 'chat'，如果不存在则返回 null
     */
    const extractFirstSegment = pathname => {
      const segments = pathname.split("/").filter(segment => segment.length > 0);
      return segments.length > 0 ? segments[0] : null;
    };
    const getFirstPathSegment = url => {
      try {
        // 尝试使用 URL 构造函数解析完整的 URL
        const parsedUrl = new URL(url);
        return extractFirstSegment(parsedUrl.pathname);
      } catch (error) {
        // 如果解析失败，假设是相对路径，使用当前窗口的位置作为基准
        if (typeof window !== "undefined") {
          const parsedUrl = new URL(url, window.location.origin);
          return extractFirstSegment(parsedUrl.pathname);
        }
        // 如果无法解析，返回 null
        return null;
      }
    };
    const goUserProfileSetting = () => {
      router.push({
        path: "/userProfileSetting"
      });
    };
    watch(() => store.showLoginDialog, newValue => {
      showLoginDialog.value = newValue;
    });
    // 监听路由变化;
    router.beforeEach((to, from, next) => {
      curPath.value = to.path;
      next();
    });
    if (curPath.value === "/external") {
      curPath.value = router.currentRoute.value.query.url;
    }
    const changeNav = item => {
      curPath.value = item.url;
      if (item.url.indexOf("http") !== -1) {
        // 外部链接
        router.push({
          path: "/external",
          query: {
            url: item.url,
            title: item.name
          }
        });
      } else {
        // 路由切换，确保路径变化
        if (router.currentRoute.value.path !== item.url) {
          router.push(item.url).then(() => {
            // 刷新 `routerViewKey` 触发视图重新渲染
            routerViewKey.value += 1;
          });
        }
      }
    };
    onMounted(() => {
      curPath.value = router.currentRoute.value.path;
      getSystemInfo().then(res => {
        logo.value = res.data.logo;
        title.value = res.data.title;
      }).catch(e => {
        ElMessage.error("获取系统配置失败：" + e.message);
      });
      // 获取菜单
      // httpGet("/menu/list")
      getNavMenuInfo().then(res => {
        mainNavs.value = res;
        // 根据窗口的高度计算应该显示多少菜单
        const rows = Math.floor((window.innerHeight - 100) / 90);
        if (res.length > rows) {
          mainNavs.value = res.slice(0, rows);
          moreNavs.value = res.slice(rows);
        }
      }).catch(e => {
        ElMessage.error("获取系统菜单失败：" + e.message);
      });
      getLicenseInfo().then(res => {
        license.value = res.data;
      }).catch(e => {
        license.value = {
          de_copy: false
        };
        showMessageError("获取 License 配置：" + e.message);
      });
      curPath.value = "/" + getFirstPathSegment(window.location.href);
      init();
    });
    const init = () => {
      checkSession().then(user => {
        loginUser.value = user;
      }).catch(() => {});
    };
    const logout = function () {
      httpPost("/system/auth/logout").then(async () => {
        removeUserToken();
        await userStore.loginOut();
        router.push("/login");
      }).catch(() => {
        ElMessage.error("注销失败！");
      });
    };
    const loginSuccess = () => {
      init();
      store.setShowLoginDialog(false);
      // 刷新组件
      routerViewKey.value += 1;
    };
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_button = _resolveComponent("el-button");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "flex-center-col",
        onClick: _cache[0] || (_cache[0] = $event => isCollapse.value = !isCollapse.value)
      }, [isCollapse.value ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        content: "展开菜单",
        placement: "right"
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("i", {
          class: "iconfont icon-expand"
        }, null, -1)])),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: _normalizeClass(["flex justify-between w-full p-[10px]", {
          'top-collapse': !isCollapse.value
        }])
      }, [!isCollapse.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[9] || (_cache[9] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: ""
      }, null, -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(title.value), 1)])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "menuIcon xxx",
        onClick: _cache[1] || (_cache[1] = $event => isCollapse.value = !isCollapse.value)
      }, [!isCollapse.value ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        content: "关闭菜单",
        placement: "right"
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("i", {
          class: "iconfont icon-colspan"
        }, null, -1)])),
        _: 1
      })) : _createCommentVNode("", true)])], 2)]), _createElementVNode("div", {
        class: _normalizeClass(["menu-list", {
          'menu-list-collapse': !isCollapse.value
        }]),
        style: _normalizeStyle({
          width: isCollapse.value ? '75px' : '170px'
        })
      }, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainNavs.value, item => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["menu-list-item flex-center-col", item.url === curPath.value ? 'active' : '']),
          key: item.url,
          onClick: $event => changeNav(item)
        }, [item.icon ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass({
            'mr-1 ml-2': !isCollapse.value
          })
        }, [_createVNode(Icon, {
          icon: item.icon,
          class: "mr-5px"
        }, null, 8, ["icon"])], 2)) : (_openBlock(), _createBlock(_component_el_image, {
          key: 1,
          src: item.icon,
          class: "el-icon ml-1"
        }, null, 8, ["src"])), _createElementVNode("div", {
          class: _normalizeClass(["menu-title", {
            'menu-title-collapse': !isCollapse.value
          }])
        }, _toDisplayString(item.name), 3)], 10, _hoisted_6);
      }), 128)), _createElementVNode("div", {
        class: "bot",
        style: _normalizeStyle({
          width: isCollapse.value ? '75px' : '170px'
        })
      }, [_cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "bot-line"
      }, null, -1)), moreNavs.value.length > 0 ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        placement: "right-end",
        trigger: "hover"
      }, {
        reference: _withCtx(() => [_createElementVNode("li", _hoisted_7, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(MoreFilled))]),
          _: 1
        }), _cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "menu-title"
        }, "更多", -1))])]),
        default: _withCtx(() => [_createElementVNode("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moreNavs.value, (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: item.url,
            class: _normalizeClass({
              active: item.url === curPath.value,
              moreTitle: index !== 3 && index !== 4,
              twoTittle: index === 3 || index === 4
            })
          }, [_createElementVNode("a", {
            onClick: $event => changeNav(item)
          }, [item.icon ? (_openBlock(), _createElementBlock("span", _hoisted_10, [_createVNode(Icon, {
            icon: item.icon,
            class: "mr-5px"
          }, null, 8, ["icon"])])) : _createCommentVNode("", true), _createElementVNode("span", {
            class: _normalizeClass(item.url === curPath.value ? 'title active' : 'title')
          }, _toDisplayString(item.name), 3)], 8, _hoisted_9)], 2);
        }), 128))])]),
        _: 1
      })) : _createCommentVNode("", true), loginUser.value.id ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 1,
        placement: "right-end",
        trigger: "hover"
      }, {
        reference: _withCtx(() => [_createElementVNode("li", _hoisted_11, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Setting))]),
          _: 1
        }), !isCollapse.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, "设置")) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_createElementVNode("ul", _hoisted_13, [_createElementVNode("li", null, [_createElementVNode("div", {
          onClick: goUserProfileSetting,
          class: "flex"
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(UserFilled))]),
          _: 1
        }), _createElementVNode("span", _hoisted_14, _toDisplayString(loginUser.value.nickname), 1)])]), _createElementVNode("li", null, [_createElementVNode("a", {
          onClick: logout,
          class: "flex"
        }, _cache[12] || (_cache[12] = [_createElementVNode("i", {
          class: "iconfont icon-logout"
        }, null, -1), _createElementVNode("span", {
          class: "title"
        }, "退出登录", -1)]))])])]),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("li", _hoisted_15, [_createElementVNode("a", {
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push('/')),
        class: "link-button"
      }, _cache[13] || (_cache[13] = [_createElementVNode("i", {
        class: "iconfont icon-house"
      }, null, -1)])), _createVNode(ThemeChange)])], 4)])], 6)]), _createVNode(_component_el_scrollbar, {
        class: "right-main"
      }, {
        default: _withCtx(() => [loginUser.value.id === undefined || !loginUser.value.id ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => _unref(router).push('/login')),
          class: "btn-go animate__animated animate__pulse animate__infinite",
          round: ""
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("登录")])),
          _: 1
        })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [(_openBlock(), _createBlock(_component_router_view, {
          key: routerViewKey.value
        }, {
          default: _withCtx(({
            Component
          }) => [_createVNode(_Transition, {
            name: "move",
            mode: "out-in"
          }, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
            _: 2
          }, 1024)]),
          _: 1
        }))])]),
        _: 1
      }), loginUser.value.id ? (_openBlock(), _createBlock(ConfigDialog, {
        key: 0,
        show: showConfigDialog.value,
        onHide: _cache[4] || (_cache[4] = $event => showConfigDialog.value = false)
      }, null, 8, ["show"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: showLoginDialog.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => showLoginDialog.value = $event),
        width: "500px",
        onClose: _cache[7] || (_cache[7] = $event => _unref(store).setShowLoginDialog(false))
      }, {
        header: _withCtx(() => _cache[16] || (_cache[16] = [_createElementVNode("div", {
          class: "text-center text-xl",
          style: {
            "color": "var(--theme-text-color-primary)"
          }
        }, "登录后解锁功能", -1)])),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(LoginDialog, {
          onSuccess: loginSuccess,
          onHide: _cache[5] || (_cache[5] = $event => _unref(store).setShowLoginDialog(false))
        })])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});